import React from 'react';
import { Create, useForm } from '@refinedev/antd';
import { Form, Input, Select, DatePicker } from 'antd';
import { ContentType, ContentStatus } from '@wellverse/shared-ts';
import { LocalizedContentTabs, normalizeTranslations } from '../../components/LocalizedContentTabs';

const LANG_FIELDS = [
  { key: 'title', label: 'Title', placeholder: 'Privacy Policy', required: true },
  { key: 'subtitle', label: 'Subtitle', placeholder: 'How we handle your data' },
  { key: 'content', label: 'Content', placeholder: 'Write your content here...', textarea: true, rows: 10, required: true },
  { key: 'summary', label: 'Summary', placeholder: 'Brief summary...', textarea: true },
];

export const ContentCreate: React.FC = () => {
  const { formProps, saveButtonProps } = useForm({ resource: 'content' });

  return (
    <Create resource="content" saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values: any) =>
          formProps.onFinish?.({
            ...values,
            translations: normalizeTranslations(values.translations, LANG_FIELDS),
          })
        }
      >
        <LocalizedContentTabs fields={LANG_FIELDS} />
        <Form.Item label="Type" name="type" rules={[{ required: true }]} initialValue={ContentType.CUSTOM}>
          <Select>
            {Object.values(ContentType).map((t) => (
              <Select.Option key={t} value={t}>
                {t}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Slug" name="slug" rules={[{ required: true }]}>
          <Input placeholder="privacy-policy-v1" />
        </Form.Item>
        <Form.Item label="Format" name="format" initialValue="markdown">
          <Select>
            <Select.Option value="markdown">Markdown</Select.Option>
            <Select.Option value="html">HTML</Select.Option>
            <Select.Option value="json">JSON</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Status" name="status" initialValue={ContentStatus.DRAFT}>
          <Select>
            {Object.values(ContentStatus).map((s) => (
              <Select.Option key={s} value={s}>
                {s}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Effective Date" name="effectiveDate">
          <DatePicker style={{ width: '100%' }} showTime />
        </Form.Item>
        <Form.Item label="Expiry Date" name="expiryDate">
          <DatePicker style={{ width: '100%' }} showTime />
        </Form.Item>
      </Form>
    </Create>
  );
};
